import {Component, OnInit, Inject} from '@angular/core';
import {ErrorStateMatcher, DateAdapter, MAT_DATE_LOCALE} from '@angular/material/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormGroup, FormControl, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {ConfirmComponent} from 'src/app/shared/dialogs/confirm/confirm.component';

import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {LetterSubscriber} from 'src/app/models/letter-subscriber';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-letter-subscription-dialog',
  templateUrl: './letter-subscription-dialog.component.html',
  styleUrls: ['./letter-subscription-dialog.component.scss'],
  entryComponents: [
    ConfirmComponent
  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'pt-BR'}
  ]
})
export class LetterSubscriptionDialogComponent implements OnInit {

  public Editor = ClassicEditor;

  public matcher = new FormErrorStateMatcher(); // 
  public entityForm: FormGroup;
  public isEdit: boolean = false;
  public spinner: boolean = false;
  public letter: LetterSubscriber;
  public types: any = [];

  public objectImage: any = null;
  public storedImage: any;

  constructor (
    public matDialogRef: MatDialogRef<LetterSubscriptionDialogComponent>,
    private fb: FormBuilder,
    private _adapter: DateAdapter<any>,
    @Inject(MAT_DIALOG_DATA) public data: LetterSubscriber
  ) {
    this.letter = this.data;

    this.types.push(
      {'id': '0', 'name': 'Requer interação'},
      {'id': '1', 'name': 'Apenas comunica'},
    )

    if (this.letter.id === "0")
      this.isEdit = false
    else
      this.isEdit = true
    //
  }

  ngOnInit () {
    this._adapter.setLocale('pt');
    this.entityForm = this.createForm(this.letter)
    this.dynamicValidation()
  }


  createForm (data: LetterSubscriber) {
    let form: FormGroup = this.fb.group({
      id: new FormControl(data.id),
      name: new FormControl(data.name, [ Validators.required ]),
      subject: new FormControl(data.subject, [ Validators.required ]),
      type: new FormControl(data.type, [ Validators.required ]),
      text: new FormControl(data.text, [ Validators.required ]),
      text_back: new FormControl(data.text_back),
      context_id: new FormControl(data.context_id, [ Validators.required ]),
      image_url:  new FormControl(data.image_url)
    });

    this.storedImage = data.image_url;
    return form
  }

  dynamicValidation () {
    // Observa mudanças no campo 'type'
    this.entityForm.get('type').valueChanges.subscribe(type => {
      const textBackControl = this.entityForm.get('text_back');
      if (type === "0") {
        // Se type for 0, adiciona a validação required
        textBackControl.setValidators([ Validators.required ]);
      } else {
        // Se type for 1, remove a validação required
        textBackControl.clearValidators();
      }
      // Atualiza o estado de validação do controle
      textBackControl.updateValueAndValidity();
    });

  }

  previewImage (event) {

    if (event.target.files.length === 0)
      return;

    var mimeType = event.target.files[ 0 ].type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }

    var reader = new FileReader();
    this.objectImage = event.target.files[ 0 ];
    reader.readAsDataURL(event.target.files[ 0 ]);
    reader.onload = (_event) => {
      this.storedImage = reader.result;
      return event.target.files[ 0 ];
    }
  }

}



